import clsx from "clsx"
import classes from "./ButtonPrev.module.scss"
import { PrevIcon } from "../Icons";
import { COLORS, useTranslate } from "@educaplay/core";
import { useDispatch, useSelector } from "react-redux";
import { decreaseIndex } from "@educaplay/store/slices/gameSlice";
import { useEffect, useState } from "react";

export default function ButtonPrev(props) {

    const {handleHover} = props;


    const dispatch = useDispatch();
    const t = useTranslate();
    const currentIndex = useSelector(state => state.game.currentIndex);
    const questions = useSelector(state => state.game.questions);
    const [passFinalQuestion, setPassFinalQuestion] = useState(false);

    useEffect(() => {

        if (currentIndex === questions.length - 1) setPassFinalQuestion(true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex])

    const navigationBackHandler = () => {
        dispatch(decreaseIndex());
    };

    return (
        <button className={clsx(classes.buttonPager, classes.buttonPager__prev)} type="button" onClick={navigationBackHandler} disabled={(currentIndex === 0 && !passFinalQuestion)} onMouseEnter={handleHover} >
            <span className={classes.buttonPager__icon}>
                <PrevIcon color={COLORS.primary}/>
            </span>
            <div className={classes.buttonPager__text}>
                {t('specific.previous')}
            </div>
        </button>)
}